import React from 'react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { t } from 'i18next';
import { WorkspaceInvitesList } from '@/routes/console/_authenticated/-features/workspace-invites-list';
import { NotificationBellButton } from '@/routes/console/_authenticated/-features/notification-bell-button';
import { Button } from '@/components/ui/button';
import { useMyInvites } from '@/hooks/use-my-invites';
export const NotificationDropdown = () => {
    const { data: invites = [] } = useMyInvites();
    return (<DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="sm" className="relative">
                    <NotificationBellButton count={invites.length}/>
                </Button>
            </DropdownMenuTrigger>

            <DropdownMenuContent align="end" className="w-90 max-h-100 overflow-y-auto">
                <div className="px-3 py-2 border-b">
                    <p className="text-sm font-medium">{t('notifications')}</p>
                </div>

                <div className="p-3">
                    <WorkspaceInvitesList />
                </div>
            </DropdownMenuContent>
        </DropdownMenu>);
};
NotificationDropdown.displayName = 'NotificationDropdown';
